import { render, staticRenderFns } from "./CloseCustomer.vue?vue&type=template&id=55e4ac0e&"
import script from "./CloseCustomer.vue?vue&type=script&lang=js&"
export * from "./CloseCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CloseCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports